import styles from "../../../styles/Components/integration/portfolio/ExchangeNewPortfolioTable.module.css";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import { formatAmount, formatPrice } from "../../../utility/helper";
import { checkIsCoin } from "../../../utility/tradeHelper";
import { FaExchangeAlt } from "react-icons/fa";
import { get200Coins } from "../../../redux/trading-assistant/actions";
import { Table } from "antd";
import ExchangePortfolioTableExpandedRow from "./ExchangePortfolioTableExpandedRow";
import { IoChevronDown, IoChevronUp } from "react-icons/io5";
import TradeButton from "../../../shared/trade-form/TradeButton";
import EmptyBox from "../../../ui/EmptyBox";

const totalBalanceRow = {
  name: "Total Balance",
  key: "totalBalance",
  asset: "-",
  availableBalance: "-",
  addToPortfolio: "-",
  usdAmount: "-",
  staking: "-",
  stopLoss: "-",
  takeProfit: "-",
  balance: {
    asset: "-",
    balance: "-",
    amount: "-",
  },
  price: "-",
  pnl: {
    value: "-",
    percent: "-",
  },
};

function ExchangeNewPortfolioTable({
  exchange,
  data,
  loading,
  error,
  height = 500,
}) {
  const {
    main: { userData },
    tradingAssistant: {
      _200Coins: { top_200_coin },
      get200CoinsLoading,
    },
  } = useSelector((state) => state);

  const [expandedRowKeys, setExpandedRowKeys] = useState([]);

  const [tableData, setTableData] = useState([]);

  const totalBalance = data.reduce((acc, cur) => {
    return (
      parseFloat(cur?.availableBalanceUSD) +
      parseFloat(cur?.stakingBalanceUSD) +
      acc
    );
  }, 0);

  const dispatch = useDispatch();
  const onRowClick = (record) => {
    if (expandedRowKeys.includes(record.key)) {
      return setExpandedRowKeys([]);
    }
    setExpandedRowKeys([record.key]);
  };

  const columns = [
    {
      title: "Balance",
      dataIndex: "balance",
      key: "balance",
      align: "center",
      responsive: ["xs", "sm"],
      width: 80,
      render: (text, record) => {
        if (text.asset === "-")
          return (
            <div className={styles.balances}>
              Total Balance: <span>{formatPrice(totalBalance)}</span>
            </div>
          );
        const isUsdt = text.asset === "USDT";
        return (
          <div className={styles.balanceData}>
            <h4 className={styles.coin}>
              <img
                src={`https://cryptocrispypro.s3.ap-southeast-2.amazonaws.com/symbol_icons/${
                  text.asset.includes("/")
                    ? text.asset.slice("/")[0]
                    : text.asset
                }.png`}
                alt={text?.asset}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/placeholders/exchange-logo.svg";
                }}
                className={styles.coinIcon}
              />
              {text?.asset}
            </h4>
            <div className={styles.balances}>
              <span>{formatAmount(text.balance)}</span>
              {!!Number(record.staking) && (
                <>
                  <br />
                  <span style={{ fontSize: "12px", color: "gray" }}>
                    ({record?.staking} Staking)
                  </span>
                </>
              )}
              {!isUsdt && <p>{formatAmount(text.amount)} USD</p>}
              {!!Number(record.stakingUsd) && (
                <>
                  <br />
                  <span style={{ fontSize: "12px", color: "gray" }}>
                    ({record.stakingUsd} USD Staking)
                  </span>
                </>
              )}
            </div>
          </div>
        );
      },
    },

    {
      title: <span className={styles.title}>Price</span>,
      dataIndex: "price",
      key: "price",
      width: 60,
      responsive: ["sm"],
      align: "center",
      render: (text) => {
        if (text === "-") return text;
        return (
          <span className={`${styles.tableContent}`}>${formatPrice(text)}</span>
        );
      },
    },
    {
      title: <span className={styles.title}>PNL</span>,
      dataIndex: "pnl",
      key: "pnl",
      width: 60,
      responsive: ["xs", "sm"],
      align: "center",
      render: ({ value, percent }) => {
        if (value === "-") return "-";
        return (
          <div className={`${styles.pnlInfo}`}>
            {!value && !percent ? (
              "-"
            ) : (
              <>
                <span
                  className={`${styles.pnl} ${
                    Number(value) > 0 ? styles.positive : ""
                  } ${Number(value) < 0 ? styles.negative : ""}`}
                >
                  {value || "-"}
                  {value && "USDT"}
                </span>
                {percent && (
                  <span
                    className={`${styles.pnlPercent}  ${
                      Number(percent) > 0 ? styles.positive : ""
                    } ${Number(percent) < 0 ? styles.negative : ""}`}
                  >
                    ({percent})%
                  </span>
                )}
              </>
            )}
          </div>
        );
      },
    },
    {
      title: <span className={styles.title}>Buy/Sell Asset</span>,
      dataIndex: "addToPortfolio",
      key: "addToPortfolio",
      width: 70,
      responsive: ["xs", "sm"],
      align: "center",
      render: (text) =>
        !top_200_coin ? (
          "..."
        ) : text === "-" ? (
          "-"
        ) : checkIsCoin(top_200_coin, text?.assetName) ? (
          <>
            <TradeButton
              btnClassName={styles.addBtn}
              data={{ coin: text?.assetName }}
            >
              <FaExchangeAlt />
            </TradeButton>
          </>
        ) : (
          "-"
        ),
    },
  ];

  useEffect(() => {
    if (!loading) {
      setTableData(
        [...(data || [])]
          .sort((a, b) => (b.assetName === "USDT" ? 1 : -1))
          .map((item) => {
            const usdAmount = Number(item?.availableBalanceUSD);
            const nativeAmount = Number(item?.availableBalance);
            return {
              key: item?.assetName,
              asset: item?.assetName,
              availableBalance: nativeAmount,
              addToPortfolio: item,
              usdAmount,
              staking: item?.stakingBalance,
              stakingUsd: item?.stakingBalanceUSD,
              stopLoss: item?.stop_loss,
              takeProfit: item?.take_profit,
              balance: {
                asset: item?.assetName,
                balance: nativeAmount,
                amount: usdAmount,
              },
              price: item?.current_price,
              pnl: {
                value: item?.pnl,
                percent: item?.pnl_percent,
              },
            };
          }),
      );
    }
  }, [data, loading]);

  useEffect(() => {
    if (
      !top_200_coin &&
      userData?.["cognito:username"] &&
      !get200CoinsLoading
    ) {
      dispatch(
        get200Coins(
          userData?.["cognito:username"],
          userData?.["custom:custom_username"],
        ),
      );
    }
  }, [dispatch, get200CoinsLoading, top_200_coin, userData]);

  useEffect(() => {
    setExpandedRowKeys([]);
  }, [exchange]);

  useEffect(() => {
    setExpandedRowKeys((keys) => {
      const next = keys.filter((key) =>
        tableData.some((row) => row.key === key),
      );
      return next.length === keys.length ? keys : next;
    });
  }, [tableData]);

  return (
    <div>
      <div className={styles.tableContainer}>
        <Table
          loading={loading}
          columns={columns}
          dataSource={tableData.length === 0 ? [] : tableData}
          pagination={false}
          height={height}
          scroll={{ y: height }}
          className={`${styles.portfolioTable} expanded-table`}
          onRow={(record) => ({
            onClick: () => onRowClick(record),
          })}
          expandable={{
            expandedRowRender: (record) => (
              <ExchangePortfolioTableExpandedRow data={record} />
            ),
            rowExpandable: (record) =>
              record.asset !== "USDT" && record.name !== "Total Balance",
            expandedRowKeys,
            expandIcon: ({ expanded, onExpand, record }) => {
              if (record.asset === "USDT" || record.name === "Total Balance")
                return "";
              if (expanded) {
                return (
                  <IoChevronUp
                    className={styles.expandIcon}
                    size={20}
                    onClick={(e) => {
                      onRowClick(record);
                    }}
                  />
                );
              } else {
                return (
                  <IoChevronDown
                    className={styles.expandIcon}
                    size={20}
                    onClick={(e) => {
                      onRowClick(record);
                    }}
                  />
                );
              }
            },
            columnWidth: 10,
          }}
          locale={{
            emptyText: loading ? (
              "Loading portfolio..."
            ) : (
              <div className={styles.noData}>
                <EmptyBox useCase={error ? "error" : "table"} size={40} />
                <span>{error ? error : "Your portfolio is empty."}</span>
              </div>
            ),
          }}
        />
      </div>
    </div>
  );
}

export default ExchangeNewPortfolioTable;
